var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIconFilled = function SvgInfoIconFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F1F2",
    fillOpacity: 0.4,
    fillRule: "evenodd",
    d: "M19.5 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0M8.75 9.75A.75.75 0 0 1 9.5 9h.253a1.75 1.75 0 0 1 1.709 2.13l-.46 2.066a.25.25 0 0 0 .245.304h.253a.75.75 0 0 1 0 1.5h-.253a1.75 1.75 0 0 1-1.709-2.13l.46-2.066a.25.25 0 0 0-.245-.304H9.5a.75.75 0 0 1-.75-.75M10.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};
export { SvgInfoIconFilled as ReactComponent };
export default __webpack_public_path__ + "a31df2de030394adc083a6459e30d366.svg";